import type { TFunction } from 'i18next'
import { createErrorMapRule } from '../utils/create-rule.ts'

export const invalidTypeRule = (t: TFunction<'validation'>) =>
  createErrorMapRule('invalid_type', t, (issue, ctx, t) => {
    const type = issue.received === 'undefined' ? 'undefined' : 'other'

    const fieldName = issue.path[issue.path.length - 1]

    return {
      message: t(`invalid_type.${type}`, {
        field: fieldName
          ? (ctx.data?.fields?.[fieldName]?.label ?? 'Field')
          : 'Field',
      }),
    }
  })
